import * as PropTypes from "prop-types";
import { images } from "/assets";

import imageMapSliderStyles from "./ImageMapSlider.css";

import { Flickity, TextCopy } from "/react/library/";

export class ImageMapSlider extends React.PureComponent {
  static propTypes = {
    markers: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    isFlightDeck: PropTypes.bool,
  };

  initialActiveMarkerId = 0;

  state = {
    currentIndex: 0,
    activeMarkerId: this.initialActiveMarkerId,
  };

  options = {
    cellAlign: "center",
    pageDots: false,
    wrapAround: false,
    adaptiveHeight: false,
    prevNextButtons: true,
  };

  componentDidMount() {
    // So our parent component highlights the first marker
    this.onChange(this.initialActiveMarkerId);
  }

  onChange(currentIndex) {
    const currentMarkerId = this.props.markers[currentIndex].id;
    this.setState({
      currentIndex: currentIndex,
      activeMarkerId: currentMarkerId,
    });
    this.props.onChange(currentMarkerId);
  }

  render() {
    const { markers } = this.props;

    return (
      <div
        className={
          this.props.isFlightDeck
            ? imageMapSliderStyles.containerFlightDeck
            : imageMapSliderStyles.container
        }
      >
        <Flickity
          onSelect={(currentIndex) => this.onChange(currentIndex)}
          options={this.options}
        >
          {markers.map((props, index) => (
            <div
              key={index}
              className={
                this.props.isFlightDeck
                  ? imageMapSliderStyles.slideFlightDeck
                  : imageMapSliderStyles.slide
              }
            >
              <TextCopy>{props.tooltip.description}</TextCopy>
            </div>
          ))}
        </Flickity>
      </div>
    );
  }
}
